import styled from "@emotion/styled";
import React from "react";
import Button, { ButtonProps } from "@/components/Button";

export const NotFoundWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 10rem;
`;

export const NotFoundImage = styled.img`
	max-width: 500px;
`;

export const NotFoundTitle = styled.p`
	display: block;
	margin-top: 60px;
	font-size: 32px;
	font-weight: 700;
	line-height: 46px;
	letter-spacing: -0.8px;
`;

export const NotFoundSubTitle = styled.p`
	text-align: center;
	margin: 12px 0;
	line-height: 1.71;
	letter-spacing: -0.2px;
	color: #666;
`;

export const HomeButton = styled(({ ...props }: ButtonProps) => <Button {...props} />)`
	margin-top: "20px";
`;
